export default __webpack_public_path__ + "static/header-iconic-link-insights-link-icon3.url-124f787d9c5758b9f4173be49e0e1ce0.svg";